import { render, staticRenderFns } from "./inmates.vue?vue&type=template&id=34ce0877&scoped=true&"
import script from "./inmates.vue?vue&type=script&lang=ts&"
export * from "./inmates.vue?vue&type=script&lang=ts&"
import style0 from "./inmates.vue?vue&type=style&index=0&id=34ce0877&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34ce0877",
  null
  
)

export default component.exports